import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useMutation, useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import PhpAPI from '../PHP/APIs/PhpAPI'

export function useStuartGet(
  path: string[],
  enabled: boolean = true,
  onSuccess?: (data: any) => void,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['PhpAPI', '/stuart', ...path],
    () => PhpAPI.get(whoAmI!, '/stuart' + path.join('')),
    {
      onError: (err) => setError(err),
      onSuccess: onSuccess,
      enabled: enabled,
    },
  )
}

export function useStuartGetPost(
  path: string[],
  payload: any,
  enabled: boolean = true,
  onSuccess?: (data: any) => void,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<any, AxiosResponse>(
    ['PhpAPI', '/stuart', ...path],
    () => PhpAPI.post(whoAmI!, '/stuart' + path.join(''), payload),
    {
      onError: (err) => setError(err),
      onSuccess: onSuccess,
      enabled: enabled,
    },
  )
}

export function useStuartMutate(
  path: string | undefined,
  onSuccess?: (data: any) => void,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse>(
    () => PhpAPI.get(whoAmI!, '/stuart' + path),
    {
      onError: (err) => setError(err),
      onSuccess: onSuccess,
    },
  )
}

export function useStuartMutatePost(
  path: string | undefined,
  payload: any,
  onSuccess?: (data: any) => void,
) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useMutation<any, AxiosResponse>(
    () => PhpAPI.post(whoAmI!, '/stuart' + path, payload),
    {
      onError: (err) => setError(err),
      onSuccess: onSuccess,
    },
  )
}
